import { Controller } from "@hotwired/stimulus"
import 'toastr/toastr'

export default class extends Controller {
  static targets = ['toastr']

  connect() {
    if (this.toastrTargets.length > 0) {
      this.toastrTargets.forEach((el) => {
        this.mount(el)
        document.addEventListener('turbolinks:before-cache', () => {
          this.unmount(el)
        }, {once: true})
      })
    }
  }

  mount(el) {
    const type = el.getAttribute('data-type')
    const message = el.getAttribute('data-message')
    const title = el.getAttribute('data-title')
    $(document).Toasts('create', {
      autohide: true,
      position: 'bottomLeft',
      delay: 5000,
      title: title,
      body: message,
      class: `bg-${type.replace('alert','warning').replace('error','danger').replace('notice','success')}`
    })
  }

  unmount(el) {

  }

}
